import { render, staticRenderFns } from "./SidebarMenuHeader.vue?vue&type=template&id=768082aa"
import script from "./SidebarMenuHeader.vue?vue&type=script&lang=js"
export * from "./SidebarMenuHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports